export type ThemeColor = 'primary' | 'error' | 'warning' | 'success' | 'background' | 'white' | 'black';

export const themeColor = (colorName: ThemeColor): string => `var(--pwp-color-${colorName})`;
